<template>
    <div>
        <div class="content-box first" v-loading="dataLoading">
            <RsStep class="full" :active="2" :steps="['身份认证', '签署合同', '签署完成']"></RsStep>
            <el-result v-if="resultCode === 1" icon="success" title="已签署完成" subTitle="">
                <template slot="extra">
                    <el-button type="primary" @click="$router.push({path: `/manage/album/list`})" size="medium">下一步</el-button>
                </template>
            </el-result>
            <el-result v-if="resultCode === 0" title="签署中">
                <template slot="icon">
                    <i class="el-icon-loading" style="font-size: 35px; color: #5914ee"></i>
                </template>
            </el-result>
            <el-result v-if="resultCode === 2 || resultCode === -1" icon="error" title="签署失败">
                <template slot="extra">
                    <el-button type="primary" @click="$contractRouter('/manage/contract/verify/fdd/step/2')" size="medium">重新签署</el-button>
                </template>
            </el-result>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            resultCode: 0,
            dataLoading: false,
        };
    },
    mounted() {
        this.getSignStatus();
    },
    methods: {
        async getSignStatus() {
            this.btnLoading = true;
            const response = await this.$request({
                url: '/letSign/signStatus',
                method: 'post',
                formData: false,
                data: {},
            });
            this.btnLoading = false;
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            this.resultCode = result.status;
            if (result.status === 1) this.$store.dispatch('getUserInfo');
            if (result.status === 0) {
                const time = setTimeout(() => {
                    clearTimeout(time);
                    this.getSignStatus();
                }, 2000);
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
